import { CheckboxFormsy, SelectFormsy, TextFieldFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { AppBar, Button, MenuItem, Toolbar, Typography } from 'material-ui';
import TextField from 'material-ui/TextField';
import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';
// import $ from "jquery";
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import { InputAdornment } from 'material-ui/Input';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import Select from 'react-select';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";

var task = [];

const styles = theme => ({
    layoutRoot: {},
    button: {
        margin: theme.spacing.unit,
    }
});


var id = null;
var job_no = null;
var job_code = null;
var enter_date = null;
var total_task_count = null;
var end_date = null;
var in_out_bound = null;
var security_level = null;
var piority_level = null;
var status = null;
var completed = null;
var task = [];


class jobsForCustomerView extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            value: '',
            jobEdit: false,
            selectedCustomer: null,
            taskView: false,
            contactPersons: [],
            brokers: [],
            employees: [],
            items: [],
            tasks: [],
            cx_data: [],
            openComposeDialog: false,
            subTasks: [],
            dataSource: []
        };

        this.editJob = this.editJob.bind(this);
        this.closeSubTaskDialog = this.closeSubTaskDialog.bind(this);
        this.setSelectedCustomer = this.setSelectedCustomer.bind(this);

    }

    setSelectedCustomer = (selectedOption) => {

        this.setState({ selectedCustomer: selectedOption });
        if (selectedOption) {
            this.loadData(selectedOption.value);
        }
        else {

            this.setState({ data: [] });
        }
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    onDelete = (model) => {
        // this.deleteEmployeeProfesionalQulificationDetail(model);
    };

    onEdit = (model) => {
        // this.editEmployeeProfesionalQulificationDetail(model);
    };
    onPrint = (job_code, in_out_bound) => {
        // this.editEmployeeProfesionalQulificationDetail(model);
        if (in_out_bound == "INBOUND") {
            var path = null;
            // axios.get('http://localhost:5008/report/get/jobRegistationInBoundDuplicate', {
            axios.get(window.reportServer + '/report/get/jobRegistationInBoundDuplicate', {
                params: {
                    jobNo: job_code
                }
            })
                .then(response => {
                    path = response.data.path;
                    // path = "http://localhost:5008/" + path;
                    path = window.reportServer + "/" + path;
                    // alert(path);

                    //this.setState({ path: path });

                    const url = path;
                    window.open(url, '_blank');


                }
                );
        } else {
            var path = null;
            axios.get(window.reportServer + '/report/get/jobRegistationOutBoundDuplicate', {
                params: {
                    jobNo: job_code
                }
            })
                .then(response => {
                    path = response.data.path;
                    // path = "http://localhost:5008/" + path;
                    path = window.reportServer + "/" + path;
                    // alert(path);

                    //this.setState({ path: path });

                    const url = path;
                    window.open(url, '_blank');


                }
                );
        }
    };

    // edit employee profesional qulification details
    editEmployeeProfesionalQulificationDetail(model) {
        // alert(model.id)
        var employeeId = model.id;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            // alert("Cannot Delete this Employee");
        } else {

            var editObj = {
                employeeId: model.id,
                nic: model.nic,
                emp_profile_id: model.emp_profile_id,
                emp_registry_id: model.emp_registry_id,
                previous_emp_name: model.previous_employer_name,
                previous_emp_address: model.previous_emp_address,
                address2: model.address2,
                state: model.state,
                city: model.city,
                zipcode: model.zipcode,
                countrycode: model.countrycode,
                email: model.email,
                telephone: model.telephone,
                designation: model.designation,
                fromddate: model.from_date,
                toddate: model.to_date,
                responsibilities: model.responsibilities
            }

            axios.post(window.hrmServer + '/hr/deleteEmpProfesionalQulification', editObj)
                .then(response => {

                    if (response.data.success) {
                        // axios.post('http://localhost:5002/hr/saveEmpProfesionalQulification', editObj)
                        axios.post(window.hrmServer + '/hr/saveEmpProfesionalQulification', editObj)
                            .then(res => {

                                if (res.data.success) {
                                    // alert("Success");
                                    this.props.alert.success("Employee Profesional Qulification Updated Successfully.");
                                    this.handleCloseEdit();
                                    this.loadData(this.state.selectedCustomer.value);
                                } else {
                                    // alert('Ivalid Credentials');
                                    this.props.alert.error("Error In Employee Profesional Qulification Update.");
                                }
                            })
                    } else {
                        // alert("Delete Faild !");
                    }
                }).catch(function (error) {
                    console.log("No internet connection or Internal error");
                });
        }
    }


    // delete employee profesional qulification details
    deleteEmployeeProfesionalQulificationDetail(model) {
        // alert(model.id)
        var employeeId = model.id;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            alert("Cannot Delete this Employee");
        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer + '/hr/deleteEmpProfesionalQulification', deleteObj)
                .then(response => {

                    if (response.data.success) {
                        // alert('Success');
                        this.props.alert.success("Employee Profesional Qulification Deleted Successfully.");
                        this.handleCloseDelete();
                        this.loadData(this.state.selectedCustomer.value);
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.error("Error In Employee Profesional Qulification Deleting.");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }
    }

    handleCheckSuspendChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };


    loadData(customerId) {

        var invoicerObj = null;

        console.log(customerId);
        // axios.get('http://localhost:5003/job/all')
        axios.post(window.crmServer + `/job/allWithTaskCountByCustomerId`, { id: customerId })
            .then(response => {
                if (response.data.length > 0) {
                    console.log(response.data)
                    var jobObj = response.data;
                    this.appendToTable(jobObj)
                }
                else {
                    alert("Jobs not Found");
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }


    appendToTable(jobObj) {

        var data = [];
        var expected_date;
        for (var i = 0; i < jobObj.length; i++) {
            var enter_date = new Date(jobObj[i].SERVICE_DATE)
            var bound;
            var job_suffix;
            var job_progress;
            var service_date = enter_date.toString().substr(0, 10);
            console.log("date " + jobObj[i].EXPECTED_DATE)
            if (jobObj[i].EXPECTED_DATE == null || jobObj[i].EXPECTED_DATE == '0000-00-00') {

                expected_date = ''
            } else {
                var end_date = new Date(jobObj[i].EXPECTED_DATE)
                expected_date = end_date.toString().substring(0, 10);
                // alert(expected_date)
                // expected_date = end_date.getFullYear() + '-' + (end_date.getMonth() + 1) + '-' + end_date.getDate();
            }

            if (jobObj[i].IS_OUTBOUND == null || jobObj[i].IS_OUTBOUND == 0) {
                bound = 'INBOUND'
            } else {
                bound = 'OUTBOUND'
            }

            if (jobObj[i].JOB_CODE_SUFFIX == null) {
                job_suffix = '';
            } else {
                job_suffix = jobObj[i].JOB_CODE_SUFFIX;
            }

            if (jobObj[i].PROGRESS == null) {
                job_progress = 0;
            } else {
                job_progress = jobObj[i].PROGRESS;
            }


            data.push({
                job_code: jobObj[i].ID_JOB_REGISTRY,
                job_no: jobObj[i].JOB_CODE_PREFIX + " " + jobObj[i].JOB_CODE + " " + job_suffix,
                enter_date: service_date,
                total_task_count: jobObj[i].RECIEVED_BY,
                end_date: expected_date,
                in_out_bound: bound,
                completed_count: jobObj[i].COMPLETED_TASKS + ' of ' + jobObj[i].TOTAL_TASKS,
                // security_level: jobObj[i].JOB_CODE_PREFIX,
                piority_level: jobObj[i].PRIORITY_LEVEL,
                status: jobObj[i].JOB_STATUS,
                completed: job_progress,
                id: jobObj[i].ID_JOB_REGISTRY,
                customer_id: jobObj[i].CUSTOMER_ID
            });
        }
        this.setState({ data: data });
        this.setState({ loading: false });
    }


    loadSearchData(searchValue) {

        const searchValueObj = {
            searchval: searchValue
        }
        var data = [];

        // axios.post('http://localhost:5002/hr/searchEmpProfesionalQulification', searchValueObj)
        axios.post(window.hrmServer + '/hr/searchEmpProfesionalQulification', searchValueObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var brokerObj = response.data.rows;

                    for (var i = 0; i < brokerObj.length; i++) {

                        data.push({
                            job_code: brokerObj[i].JOB_CODE,
                            job_no: brokerObj[i].CODE,
                            enter_date: brokerObj[i].NAME,
                            total_task_count: brokerObj[i].REFERENCE_NUMBER,
                            end_date: brokerObj[i].REFERENCE_NUMBER,
                            in_out_bound: brokerObj[i].TITLE,
                            // security_level: brokerObj[i].NIC,
                            piority_level: brokerObj[i].ADDRESS,
                            status: 'Active',
                            completed: brokerObj[i].STATE
                        });
                    }
                }
                this.setState({ data: data });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }



    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }


    taskView = (id) => {

        axios.post(window.crmServer + '/job/subTasks', { id: id })
            .then(response => {
                this.setState({
                    taskView: true,
                    dataSource: response.data
                });
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
            });
    }


    editJob = (data) => {

        this.setState({ loading: true });
        task = [];

        axios.post(window.crmServer + '/job/byId', { id: data })
            .then(response => {

                axios.post(window.crmServer + '/crm/getCustomer/byId', { id: response.data.profileData[0].CUSTOMER_ID })
                    .then(response1 => {

                        console.log(response.data);
                        console.log(response1.data);

                        var cp_index = response.data.profileData[0].ID_CONTACT_PERSON;

                        this.setState({ serviceDate: response.data.profileData[0].SERVICE_DATE.substr(0, 10) });
                        this.setState({ nextServiceDate: response.data.profileData[0].NEXT_SERVICE_DATE.substr(0, 10) });
                        this.setState({ expectedDate: response.data.profileData[0].EXPECTED_DATE.substr(0, 10) });
                        this.setState({ postalAddress: response1.data[0].CUSTOMER_PROFILE.cx_postal_address });
                        this.setState({ billingAddress: response1.data[0].CUSTOMER_PROFILE.cx_billing_address });
                        this.setState({ contactPersons: response1.data[0].CONTACT_PERSONS });
                        this.setState({ contactPersonsIndex: cp_index });
                        this.setState({ contactPersonsName: response1.data[0].CONTACT_PERSONS[cp_index].name });
                        this.setState({ contactPersonsMobile: response1.data[0].CONTACT_PERSONS[cp_index].phone_mobile });
                        this.setState({ contactPersonsHome: response1.data[0].CONTACT_PERSONS[cp_index].phone_home });
                        this.setState({ contactPersonsOffice: response1.data[0].CONTACT_PERSONS[cp_index].phone_office });
                        this.setState({ contactPersonsEmail: response1.data[0].CONTACT_PERSONS[cp_index].email });
                        this.setState({ frequency: response.data.profileData[0].FREQUANCY });
                        this.setState({ priority_level: response.data.profileData[0].PRIORITY_LEVEL });
                        this.setState({ brokerId: response.data.profileData[0].HANDOVER_BY });
                        this.setState({ employeeId: response.data.profileData[0].RECEIVED_BY });
                        this.setState({ jobCode: response.data.profileData[0].JOB_CODE });
                        this.setState({ idRegistry: response.data.profileData[0].ID_JOB_REGISTRY });
                        this.setState({ idProfile: response.data.profileData[0].ID_JOB_PROFILE });
                        this.setState({ idCustomer: response.data.profileData[0].CUSTOMER_ID });
                        this.setState({ isOutbound: response.data.profileData[0].IS_OUTBOUND });
                        // this.setState({jobCode:response.data.profileData[0].JOB_CODE_PREFIX+' '+response.data.profileData[0].JOB_CODE+' '+response.data.profileData[0].JOB_CODE_SUFFIX});

                        //=======================================================================================================


                        for (var i = 0; response.data.taskData.length > i; i++) {

                            var subTask = [];

                            for (var n = 0; response.data.subTaskData.length > n; n++) {

                                if (response.data.taskData[i].ID_JOB_TASK == response.data.subTaskData[n].ID_JOB_TASK) {

                                    subTask.push({
                                        'subTask_code': response.data.subTaskData[n].SUB_TASK_CODE,
                                        'subTask_code_suffix': "",
                                        'subTask_type': response.data.subTaskData[n].SUB_TASK_TYPE,
                                        'subTask_instrument': response.data.subTaskData[n].SUB_TASK_INSTRUMENT,
                                        'subTask_instrument_id': response.data.subTaskData[n].SUB_TASK_INSTRUMENT_ID,
                                    });
                                }
                            }

                            task.push({
                                'task_code': response.data.taskData[i].ID_TASK_CODE,
                                'task_code_suffix': "",
                                'task_type': response.data.taskData[i].TASK_TYPE,
                                'task_qty': response.data.taskData[i].TASK_QTY,
                                'task_instrument': response.data.taskData[i].TASK_INSTRUMENT,
                                'task_instrument_id': response.data.taskData[i].TASK_INSTRUMENT_ID,
                                'task_remark': response.data.taskData[i].REMARK,
                                'sub_tasks': subTask,
                                'editable': false
                            });
                        }

                        this.setState({ loading: false });
                        this.setState({ tasks: task });

                        //===========================================================================================================

                        this.setState({ jobEdit: true });

                    }).catch(function (error) {
                        console.log("err " + error);
                        console.log("No internet connection or Internal error");
                    });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
            });

    }






    updateJob = (formData) => {

        // if(!formData.job_is_outbound && formData.job_expected_date === " "){

        //     this.props.alert.error("Expected Completed Date Required for Inbound Jobs");
        // }

        // else{

        this.setState({ loading: true });
        var data = {

            'jobGeneral': formData,
            'jobTasks': this.state.tasks
        }

        task = [];
        this.setState({ tasks: task });
        this.setState({ jobCustomer: null });
        this.setState({ jobItem: null });

        // axios.post('http://localhost:5003/job/updateJob',data)
        axios.post(window.crmServer + '/job/updateJob', data)
            .then(response => {

                if (response.data.status) {

                    // var report = '';

                    // if(formData.job_is_outbound) report = window.reportServer+'/report/get/jobRegistationOutBound';
                    // else report = window.reportServer+'/report/get/jobRegistationInBound';

                    // var path = null;
                    // axios.get(report, {
                    // params: {
                    // jobNo: response.data.id
                    // }
                    // })
                    // .then(response2 => {
                    // path = response2.data.path;
                    // path = window.reportServer+"/" + path;

                    // const url = path;
                    // window.open(url, '_blank');

                    // }
                    // );
                    this.setState({ loading: false });
                    this.setState({ jobEdit: false });
                    this.props.alert.success(response.data.msg);
                }

                else {
                    this.setState({ loading: false });
                    this.setState({ jobEdit: false });
                    this.props.alert.error(response.data.msg);
                }
            });

        // }
    }


    getCustomerList() {
        this.setState({ loading: true });
        var customers = [];
        var param = '';
        if (this.state.startDate && this.state.endDate) {
            param = 'startDate=' + this.state.startDate + '&endDate=' + this.state.endDate;
        }

        // axios.get('http://localhost:5003/crm/getCustomer/all')
        axios.get(window.crmServer + '/crm/getCustomer/all' + (param != '' ? '?' + param : ''))
            .then(response => {

                for (let i = 0; i < response.data.length; i++) {

                    if (response.data[i].CUSTOMER_PROFILE.cx_active) {
                        customers.push({
                            value: response.data[i]._id,
                            label: response.data[i].CUSTOMER_CODE_PREFIX + ' ' + response.data[i].CUSTOMER_CODE + ' ' + response.data[i].CUSTOMER_CODE_SUFFIX + ' | ' + response.data[i].CUSTOMER_PROFILE.cx_name,
                        });
                    }
                    else if (!response.data[i].CUSTOMER_PROFILE.cx_active) {
                        customers.push({
                            value: response.data[i]._id,
                            label: response.data[i].CUSTOMER_CODE_PREFIX + ' ' + response.data[i].CUSTOMER_CODE + ' ' + response.data[i].CUSTOMER_CODE_SUFFIX + ' | ' + response.data[i].CUSTOMER_PROFILE.cx_name,
                        });
                    }
                }
                console.log(customers);
                this.setState({ loading: false });
                this.setState({ cx_data: customers });
            });
    }



    setNextServiceDate = (data) => {
        // alert(data.target.name);

        if (data.target.name == 'job_frequency_tmp') {

            this.setState({ frequency: data.target.value }, () => {
                var nextServiceDate = this.state.serviceDate;
                var n = parseInt(this.state.frequency);
                // alert(nextServiceDate);
                // alert(n);

                var d = new Date(nextServiceDate);
                var dt = new Date(d.setMonth(d.getMonth() + n));
                var nextServiceDate = dt.getFullYear() + "-" + ("0" + ((dt.getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (dt.getDate().toString())).substr(-2);
                this.setState({ nextServiceDate: nextServiceDate });
            });
        }

        else {
            var nextServiceDate = this.state.serviceDate;
            var n = parseInt(this.state.frequency);
            // alert(nextServiceDate);
            // alert(n);

            var d = new Date(nextServiceDate);
            var dt = new Date(d.setMonth(d.getMonth() + n));
            var nextServiceDate = dt.getFullYear() + "-" + ("0" + ((dt.getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (dt.getDate().toString())).substr(-2);
            this.setState({ nextServiceDate: nextServiceDate });
        }
    }

    changeContactPerson = (index) => {

        if (index + 1 < this.state.contactPersons.length) {
            this.refs.job_cp_name.setValue(this.state.contactPersons[index].name);
            this.refs.job_cp_mobile.setValue(this.state.contactPersons[index].phone_mobile);
            this.refs.job_cp_office.setValue(this.state.contactPersons[index].phone_office);
            this.refs.job_cp_home.setValue(this.state.contactPersons[index].phone_home);
            this.refs.job_cp_email.setValue(this.state.contactPersons[index].email);
            this.setState({ contactPersonsIndex: index + 1 });
        }

        if (index + 1 == this.state.contactPersons.length) {
            this.refs.job_cp_name.setValue(this.state.contactPersons[index].name);
            this.refs.job_cp_mobile.setValue(this.state.contactPersons[index].phone_mobile);
            this.refs.job_cp_office.setValue(this.state.contactPersons[index].phone_office);
            this.refs.job_cp_home.setValue(this.state.contactPersons[index].phone_home);
            this.refs.job_cp_email.setValue(this.state.contactPersons[index].email);
            this.setState({ contactPersonsIndex: 0 });
        }
    }


    addTask = () => {

        if (this.refs.task_instrument_id.getValue() != '') {

            var subTask = [];

            for (var i = 0; parseInt(this.refs.task_qty.getValue()) > i; i++) {

                subTask.push({
                    'subTask_code': this.state.jobCode + ' ' + ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue() + ' ' + ('0' + (i + 1).toString()).substr(-2),
                    'subTask_code_suffix': ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue() + ' ' + ('0' + (i + 1).toString()).substr(-2),
                    'subTask_type': this.refs.task_service_type.getValue(),
                    'subTask_instrument': this.refs.task_instrument_name.getValue(),
                    'subTask_instrument_id': this.refs.task_instrument_id.getValue(),
                });
            }

            task.push({
                'task_code': this.state.jobCode + ' ' + ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue(),
                'task_code_suffix': ('0' + (this.state.tasks.length + 1).toString()).substr(-2) + ' ' + this.refs.task_service_type.getValue(),
                'task_type': this.refs.task_service_type.getValue(),
                'task_qty': this.refs.task_qty.getValue(),
                'task_instrument': this.refs.task_instrument_name.getValue(),
                'task_instrument_id': this.refs.task_instrument_id.getValue(),
                'task_remark': this.refs.task_remark.getValue(),
                'sub_tasks': subTask,
                'editable': true
            });

            this.setState({ tasks: task });
            this.setState({ jobItem: null });

            this.refs.task_service_type.setValue("C");
            this.refs.task_qty.setValue("1");
            this.refs.task_instrument_name.setValue("");
            this.refs.task_instrument_id.setValue("");
            this.refs.task_remark.setValue("");

        }
    }

    removeTask = (element) => {

        var taskNew = [];

        task = [...this.state.tasks];
        var index = task.indexOf(element)
        task.splice(index, 1);

        for (var i = 0; task.length > i; i++) {
            if (task[i].editable) {
                taskNew.push({
                    'task_code': this.state.jobCode + ' ' + ('0' + (i + 1).toString()).substr(-2) + ' ' + task[i].task_type,
                    'task_code_suffix': ('0' + (i + 1).toString()).substr(-2) + ' ' + task[i].task_type,
                    'task_type': task[i].task_type,
                    'task_qty': task[i].task_qty,
                    'task_instrument': task[i].task_instrument,
                    'task_instrument_id': task[i].task_instrument_id,
                    'task_remark': task[i].task_remark,
                    'sub_tasks': task[i].sub_tasks,
                    'editable': task[i].editable,
                });
            }
            else {
                taskNew.push({
                    'task_code': task[i].task_code,
                    'task_code_suffix': "",
                    'task_type': task[i].task_type,
                    'task_qty': task[i].task_qty,
                    'task_instrument': task[i].task_instrument,
                    'task_instrument_id': task[i].task_instrument_id,
                    'task_remark': task[i].task_remark,
                    'sub_tasks': task[i].sub_tasks,
                    'editable': task[i].editable,
                });
            }
        }

        this.setState({ tasks: taskNew });
    }


    setJobItem = (selectedOption) => {

        this.setState({ jobItem: selectedOption });
        if (selectedOption) {

            this.refs.task_instrument_name.setValue(selectedOption.label);
            this.refs.task_instrument_id.setValue(selectedOption.value);

        }
        else {

            this.refs.task_instrument_name.setValue('');
            this.refs.task_instrument_id.setValue('');
        }
    }


    printCode = (id, customer_id) => {

        var path = null;
        axios.get(window.reportServer + '/report/get/printTaskCode', {
            params: {
                id: id,
                customer_id: customer_id
            }
        })
            .then(response => {
                path = response.data.path;
                path = window.reportServer + "/" + path;

                const url = path;
                window.open(url, '_blank');
            })
    }

    openSubTaskDialog(element) {
        this.setState({ subTasks: element });
        this.setState({ openComposeDialog: true });
    }

    closeSubTaskDialog() {
        this.setState({ openComposeDialog: false });
    }


    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-20">
                            <h2 className="subtitle-color invoice-margin">Search Customer Jobs</h2>
                        </div>
                        <div className="p-20">

                            <div className="w-full md:w-1/4 inline-block mr-56">
                                <Select
                                    className="job-task-padding"
                                    name="job_code"
                                    placeholder="Search/Select Customer"
                                    value={this.state.selectedCustomer}
                                    onChange={this.setSelectedCustomer}
                                    options={this.state.cx_data}
                                />
                            </div>
                        </div>
                        <div className="p-20">

                            <div className="flex flex-wrap -mx-3 mb-12">
                                <div className="w-full md:w-2/3"></div>
                                {/* <div className="w-full md:w-1/3">

                                <TextField
                                    placeholder="Search for anything"
                                    className="pl-16"
                                    fullWidth
                                    value={this.state.value}
                                    inputProps={{
                                        'aria-label': 'Search'
                                    }}
                                    onChange={this.handleSearchAny}
                                />
                                {/* <Icon className="-mb-4 -mr-4" color="action">search</Icon> */}
                                {/* </div> */}
                            </div>


                            <div class="flex h-auto">

                                <div class="w-full bg-white h-auto">
                                    <ReactTable

                                        getTrProps={(state, rowInfo, column) => {
                                            return {
                                                className: "cursor-pointer",
                                                onClick: (e, handleOriginal) => {

                                                }
                                            }
                                        }}
                                        data={this.state.data}
                                        columns={[
                                            {
                                                Header: "Job No",
                                                accessor: "job_no",
                                                filterable: true

                                            },
                                            {
                                                Header: "Entered Date",
                                                accessor: "enter_date",
                                                filterable: true

                                            },
                                            {
                                                Header: "Completed Tasks",
                                                accessor: "completed_count",
                                                className: "justify-center",
                                                filterable: true

                                            },
                                            {
                                                Header: "Expected End Date",
                                                accessor: "end_date",
                                                filterable: true

                                            },
                                            {
                                                Header: "Inbound/Outbound",
                                                accessor: "in_out_bound",
                                                filterable: true

                                            },
                                            // {
                                            //     Header: "Security Level",
                                            //     accessor: "security_level",
                                            //     filterable: true

                                            // },
                                            {
                                                Header: "Piority Level",
                                                accessor: "piority_level",
                                                filterable: true

                                            },
                                            {
                                                Header: "Completed(%)",
                                                accessor: "completed",
                                                filterable: true,
                                                Cell: row => (
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            height: '40%',
                                                            backgroundColor: '#dadada',
                                                            borderRadius: '2px'
                                                        }}
                                                    >
                                                        <div
                                                            title={row.value + '%'}
                                                            style={{
                                                                width: `${row.value}%`,
                                                                height: '100%',
                                                                backgroundColor: row.value > 66 ? '#85cc00'
                                                                    : row.value > 33 ? '#ffbf00'
                                                                        : '#ff2e00',
                                                                borderRadius: '2px',
                                                                transition: 'all .2s ease-out'
                                                            }}
                                                        />
                                                    </div>
                                                )

                                            },
                                            {
                                                Header: "Status",
                                                accessor: "status",
                                                className: "justify-center",
                                                Cell: row => (
                                                    <div className="flex items-center">
                                                        {row.value === 'Completed' ? <span className='text-green-light'>
                                                            {row.value}
                                                        </span>
                                                            : row.value === 'Pending' ? <span className='text-red-light'>
                                                                {row.value}
                                                            </span>
                                                                : row.value === 'In Progress' ? <span className='text-orange-light'>
                                                                    {row.value}
                                                                </span>
                                                                    : 'text-orange-light'
                                                        }

                                                    </div>
                                                )

                                            },
                                            {
                                                Header: "Action",
                                                // accessor: "su",
                                                width: 200,
                                                Cell: row => (
                                                    <div className="flex items-center w-8 h-8">
                                                        <IconButton

                                                            onClick={(e) => {
                                                                this.taskView(row.original.id);
                                                            }}

                                                            title="Sub Task List"
                                                        >
                                                            <Icon className="">group</Icon>

                                                        </IconButton>
                                                        <IconButton

                                                            onClick={(e) => {
                                                                if (row) {
                                                                    // previous_employer_name = row.original.previous_employer_name;
                                                                    job_code = row.original.job_code;
                                                                    in_out_bound = row.original.in_out_bound;
                                                                    // nic = row.original.nic;
                                                                    // previous_emp_address = row.original.previous_emp_address;
                                                                    // address2 = row.original.address2;
                                                                    // state = row.original.state;
                                                                    // city = row.original.city;
                                                                    // zipcode = row.original.zipcode;
                                                                    // countrycode = row.original.countrycode;
                                                                    // email = row.original.email;
                                                                    // telephone = row.original.telephone;
                                                                    // designation = row.original.designation;
                                                                    // from_date = row.original.from_date;
                                                                    // to_date = row.original.to_date;
                                                                    // responsibilities = row.original.responsibilities;
                                                                    // emp_profile_id = row.original.emp_profile_id;
                                                                    // emp_registry_id = row.original.emp_registry_id;
                                                                    // this.setState({ edit: true });
                                                                    this.onPrint(job_code, in_out_bound)
                                                                }
                                                            }}

                                                            title="Registration Form"

                                                        >
                                                            <Icon className="text-blue">print</Icon>
                                                        </IconButton>
                                                        <IconButton

                                                            onClick={(e) => {


                                                                this.printCode(row.original.id, row.original.customer_id);
                                                            }}

                                                            title="Stickers"
                                                        >
                                                            <Icon className="text-green">print</Icon>

                                                        </IconButton>



                                                        {/* /////me */}
                                                        <Dialog

                                                            open={this.state.edit}
                                                            onClose={this.handleCloseEdit}
                                                            aria-labelledby="form-dialog-title"
                                                        >
                                                            <Formsy
                                                                onValidSubmit={this.onEdit}
                                                                onValid={this.enableButtonEdit}
                                                                onInvalid={this.disableButtonEdit}
                                                                ref={(form) => this.form = form}
                                                                className=""
                                                            >
                                                                <DialogTitle id="form-dialog-title">Edit Profesional Qualification Details</DialogTitle>
                                                                <DialogContent className="flex flex-wrap">

                                                                    <div className="w-full">

                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="id"
                                                                        // value={id}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="emp_profile_id"
                                                                        // value={emp_profile_id}
                                                                        />
                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="emp_registry_id"
                                                                        // value={emp_registry_id}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/3 pr-8"
                                                                            type="text"
                                                                            name="nic"
                                                                            label="NIC No"
                                                                            // value={nic}
                                                                            required
                                                                            disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/3 pr-8"
                                                                            type="text"
                                                                            name="previous_employer_name"
                                                                            label="Previous Employer Name"
                                                                        // value={previous_employer_name}

                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/3"
                                                                            type="text"
                                                                            name="address2"
                                                                            label="Address 2"
                                                                        // value={address2}

                                                                        />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-full mt-16"
                                                                            type="text"
                                                                            name="previous_emp_address"
                                                                            label="Previous Employer Address"
                                                                        // value={previous_emp_address}
                                                                        // required
                                                                        // disabled={true}
                                                                        />
                                                                    </div>
                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-full mt-16"
                                                                            type="text"
                                                                            name="responsibilities"
                                                                            label="Duties and Responsibilities"
                                                                        // value={responsibilities}
                                                                        // required
                                                                        // disabled={true}
                                                                        />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-full mt-16"
                                                                            type="text"
                                                                            name="state"
                                                                            label="State"
                                                                        // value={state}
                                                                        // required
                                                                        // disabled={true}
                                                                        />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-1/2 pr-8 mt-16"
                                                                            type="text"
                                                                            name="city"
                                                                            label="City"
                                                                        // value={city}
                                                                        // required
                                                                        // disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/2 mt-16"
                                                                            type="text"
                                                                            name="email"
                                                                            label="Email"
                                                                            // value={email}
                                                                            validations="isEmail"
                                                                            validationError="This is not a valid email"
                                                                        />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-1/2 pr-8 mt-16"
                                                                            type="text"
                                                                            name="telephone"
                                                                            label="Telephone"
                                                                        // value={telephone}
                                                                        // disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/2 mt-16"
                                                                            type="text"
                                                                            name="designation"
                                                                            label="Designation"
                                                                        // value={designation}
                                                                        // disabled={true}
                                                                        />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <TextFieldFormsy
                                                                            className="w-1/4 pr-8 mt-16"
                                                                            type="date"
                                                                            name="from_date"
                                                                            label="From Date"
                                                                        // value={from_date}
                                                                        // disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/4 pr-8 mt-16"
                                                                            type="date"
                                                                            name="to_date"
                                                                            label="To Date"
                                                                        // value={to_date}
                                                                        // disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/4 pr-8 mt-8"
                                                                            type="text"
                                                                            name="zipcode"
                                                                            label="Zip Code"
                                                                        // value={zipcode}
                                                                        // disabled={true}
                                                                        />

                                                                        <TextFieldFormsy
                                                                            className="w-1/4 pr-8 mt-8"
                                                                            type="text"
                                                                            name="countrycode"
                                                                            label="Country Code"
                                                                        // value={countrycode}
                                                                        // disabled={true}
                                                                        />
                                                                    </div>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                                        Close
                                                                    </Button>

                                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                                        Update
                                                                    </Button>
                                                                </DialogActions>
                                                            </Formsy>
                                                        </Dialog>


                                                        {/* /////me */}

                                                        {/* <IconButton
                                                        onClick={(e) => {
                                                            if (row) {

                                                                // updateTradeId = row.original.superTradeId;
                                                                // updateTradeName = row.original.superTradeName;
                                                                // isActive = row.original.isActive;
                                                                this.setState({ delete: true });
                                                                id = row.original.id;
                                                                // alert(id);


                                                            }
                                                        }}

                                                    >
                                                        <Icon className="text-red-light">delete</Icon>
                                                    </IconButton> */}


                                                        {/* /////me */}

                                                        <Dialog
                                                            open={this.state.delete}
                                                            onClose={this.handleClose}
                                                            aria-labelledby="form-dialog-title"
                                                        >
                                                            <DialogTitle id="form-dialog-title">Delete Profesional Qualification</DialogTitle>
                                                            <DialogContent>

                                                                <div>

                                                                    <Formsy
                                                                        onValidSubmit={this.onDelete}
                                                                        onValid={this.enableButtonDelete}
                                                                        onInvalid={this.disableButtonDelete}
                                                                        ref={(form) => this.form = form}
                                                                        className="flex flex-col justify-center"
                                                                    >
                                                                        <TextFieldFormsy
                                                                            type="hidden"
                                                                            name="id"
                                                                            value={id}
                                                                        />

                                                                        <DialogActions>
                                                                            <Button onClick={this.handleCloseDelete} color="primary">
                                                                                Cancel
                                                                            </Button>

                                                                            <Button
                                                                                type="submit"
                                                                                variant="raised"
                                                                                color="primary"
                                                                                className="mx-auto mt-16 pb-15"
                                                                                aria-label="Edit"
                                                                            // disabled={!canEdit}
                                                                            >
                                                                                Change
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Formsy>
                                                                </div>
                                                            </DialogContent>


                                                        </Dialog>

                                                        {/* ///// */}


                                                    </div>
                                                )
                                            }

                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    <Dialog
                        fullWidth={true}
                        maxWidth={'md'}
                        open={this.state.taskView}
                        onClose={() => { this.setState({ taskView: false }) }}
                        aria-labelledby="max-width-dialog-title"
                        scroll={'body'}
                    >
                        <DialogTitle id="max-width-dialog-title">Sub Task List
                            {/* <IconButton color="inherit" onClick={() => { this.setState({ taskView: false }) }} aria-label="Close">
                            <CloseIcon />
                        </IconButton> */}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <ReactTable
                                    className="-striped -highlight w-full"
                                    data={this.state.dataSource}
                                    columns={[

                                        {
                                            Header: "Code",
                                            accessor: "SUB_TASK_CODE",
                                            filterable: true
                                        },
                                        {
                                            Header: "Type",
                                            accessor: "SUBTASK_ASSIGN_TYPE",
                                            filterable: true,
                                            Cell: row => (
                                                row.original.SUBTASK_ASSIGN_TYPE == "C" || row.original.SUB_TASK_TYPE == "C" ? "Calibrate" : row.original.SUBTASK_ASSIGN_TYPE == "R" || row.original.SUB_TASK_TYPE == "R" ? "Repair" : "Repair & Calibrate"
                                            )
                                        },
                                        {
                                            Header: "Instrument",
                                            accessor: "SUB_TASK_INSTRUMENT",
                                            filterable: true
                                        },
                                        {
                                            Header: "Employee",
                                            accessor: "FIRST_NAME",
                                            filterable: true,
                                            Cell: row => (
                                                row.original.FIRST_NAME ?
                                                    row.original.FIRST_NAME + " " + row.original.LAST_NAME
                                                    :
                                                    "Not Assigned"
                                            )
                                        },
                                        {
                                            Header: "Status",
                                            accessor: "SUBTASK_ASSIGN_STATUS",
                                            filterable: true,
                                            Cell: row => (
                                                row.original.SUBTASK_ASSIGN_STATUS ?
                                                    row.original.SUBTASK_ASSIGN_STATUS
                                                    :
                                                    "Pending"
                                            )
                                        },

                                    ]}
                                    defaultPageSize={5}
                                    noDataText="No Tasks"
                                />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { this.setState({ taskView: false }) }} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={this.state.jobEdit}
                        fullScreen
                        className="z-20"
                    >
                        <Formsy
                            onValidSubmit={this.updateJob}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                        >
                            {/* <DialogTitle id="form-dialog-title">Edit Job Details</DialogTitle> */}
                            <AppBar className="flex w-full app-bar-size" position="static">
                                <Toolbar className="flex w-full">
                                    <Typography className="w-full" variant="subheading" color="inherit">
                                        Edit Job Details
                                    </Typography>
                                    <IconButton className="" color="inherit" onClick={(e) => {
                                        this.setState({ jobEdit: false });
                                    }}
                                        aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <DialogContent className="flex flex-wrap">

                                <div className="flex flex-wrap">
                                    <div className="w-full md:w-2/5 px-12 py-44">

                                        <TextFieldFormsy
                                            type="hidden"
                                            name="job_customer_id"
                                            value={this.state.idCustomer}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="job_registry_id"
                                            value={this.state.idRegistry}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="job_profile_id"
                                            value={this.state.idProfile}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="jobCode"
                                            value={this.state.jobCode}
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-2/5 float-right"
                                            type="date"
                                            name="job_date_tmp"
                                            label="Date of Service"
                                            value={this.state.serviceDate}
                                            disabled
                                        />

                                        <CheckboxFormsy
                                            className=" float-left"
                                            name="job_is_outbound"
                                            label="Outbound"
                                            value={this.state.isOutbound}
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full mt-12"
                                            type="text"
                                            name="job_postal_address"
                                            ref="job_postal_address"
                                            label="Postal Address"
                                            value={this.state.postalAddress}
                                            required
                                            disabled
                                        />

                                        <TextFieldFormsy
                                            className="w-full mt-12"
                                            type="text"
                                            name="job_billing_address"
                                            ref="job_billing_address"
                                            label="Billing Address"
                                            value={this.state.billingAddress}
                                            required
                                            disabled
                                        />

                                        <div className="w-full px-8 mt-12 border-solid border-1 border-grey bg-grey-lighter">
                                            {this.state.contactPersons.length > 1 ? (
                                                <IconButton
                                                    color="secondary"
                                                    className=' mt-8 float-right'
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.changeContactPerson(this.state.contactPersonsIndex);
                                                    }}
                                                >
                                                    <Icon>autorenew</Icon>
                                                    {/* {this.state.contactPersonsIndex+1}
                         of
                        {this.state.contactPersons.length} */}
                                                </IconButton >
                                            ) : ("")}

                                            <TextFieldFormsy
                                                type="hidden"
                                                name="job_cp_id"
                                                value={this.state.contactPersonsIndex}
                                            />

                                            <TextFieldFormsy
                                                className="w-5/6 mb-12 mt-12 mx-12"
                                                type="text"
                                                name="job_cp_name"
                                                ref="job_cp_name"
                                                label="Contact Person"
                                                value={this.state.contactPersonsName}
                                                disabled
                                            />

                                            <TextFieldFormsy
                                                className="md:w-2/5 mb-12 mx-12"
                                                type="text"
                                                name="job_cp_mobile"
                                                ref="job_cp_mobile"
                                                label="Mobile"
                                                value={this.state.contactPersonsMobile}
                                                disabled
                                            />
                                            <TextFieldFormsy
                                                className="md:w-2/5 mb-12 mx-12"
                                                type="text"
                                                name="job_cp_office"
                                                ref="job_cp_office"
                                                label="Office"
                                                value={this.state.contactPersonsOffice}
                                                disabled
                                            />
                                            <TextFieldFormsy
                                                className="md:w-2/5 mb-12 mx-12"
                                                type="text"
                                                name="job_cp_home"
                                                ref="job_cp_home"
                                                label="Home"
                                                value={this.state.contactPersonsHome}
                                                disabled
                                            />
                                            <TextFieldFormsy
                                                className="md:w-2/5 mb-12 mx-12"
                                                type="text"
                                                name="job_cp_email"
                                                ref="job_cp_email"
                                                label="Email"
                                                value={this.state.contactPersonsEmail}
                                                disabled
                                            />
                                        </div>

                                        <TextField
                                            className="w-full md:w-1/3 mt-20"
                                            type="number"
                                            name="job_frequency_tmp"
                                            value={this.state.frequency}
                                            onChange={(ev) => {
                                                this.setNextServiceDate(ev);
                                            }}
                                            label="Frequency"
                                            required
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">Months</InputAdornment>,
                                            }}
                                        />

                                        <TextFieldFormsy
                                            type="hidden"
                                            name="job_frequency"
                                            value={this.state.frequency}
                                        />

                                        <TextFieldFormsy
                                            className="w-full md:w-2/5 mt-20 float-right"
                                            type="date"
                                            name="job_next_service_date"
                                            label="Next Service Date"
                                            value={this.state.nextServiceDate}
                                            required={window.env === "IMC" ? false : true}
                                        />
                                        <SelectFormsy
                                            className="w-full md:w-1/3 mt-20"
                                            name="job_priority"
                                            label="Priority Level"
                                            value={this.state.priority_level}
                                            required
                                        >
                                            <MenuItem className="popup-value-size" key='1' value='High'>High</MenuItem>
                                            <MenuItem className="popup-value-size" key='2' value='Normal'>Normal</MenuItem>
                                            <MenuItem className="popup-value-size" key='3' value='Low'>Low</MenuItem>
                                        </SelectFormsy>
                                        <TextFieldFormsy
                                            className="w-full md:w-2/5 mt-20 float-right"
                                            type="date"
                                            value=" "
                                            name="job_expected_date"
                                            label="Expected Completed Date *"
                                            value={this.state.expectedDate}
                                        />
                                        <SelectFormsy
                                            className="w-full md:w-1/2 mt-12 pr-20"
                                            name="job_handover_by"
                                            label="Handover By"
                                            value={this.state.brokerId}
                                        >
                                            {this.state.brokers.map(option => (
                                                <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </SelectFormsy>
                                        <SelectFormsy
                                            className="w-full md:w-1/2 mt-12"
                                            name="job_recieved_by"
                                            label="Recieved By"
                                            value={this.state.employeeId}
                                        >
                                            {this.state.employees.map(option => (
                                                <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </SelectFormsy>

                                        <div className="w-full">
                                            <Button
                                                className="m-4 mt-20 float-right"
                                                variant="raised"
                                                color="default"
                                            >
                                                Help
                                            </Button>
                                            <Button
                                                type="button"
                                                className="m-4 mt-20 float-right"
                                                variant="raised"
                                                color="primary"
                                                onClick={(ev) => {
                                                    this.setState({ jobEdit: false });
                                                }}
                                            >
                                                Close
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="m-4 mt-20 float-right"
                                                variant="raised"
                                                color="secondary"
                                            >
                                                Update
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="w-full md:w-3/5 px-12 py-24">


                                        <SelectFormsy
                                            className="w-full md:w-1/4 mt-20 pr-12"
                                            name="task_service_type"
                                            ref="task_service_type"
                                            label="Service Type"
                                            value="C"
                                        >
                                            <MenuItem className="popup-value-size" key='1' value='C'>Calibrate</MenuItem>
                                            <MenuItem className="popup-value-size" key='2' value='R'>Repair</MenuItem>
                                            <MenuItem className="popup-value-size" key='3' value='RC'>Repair & Calibrate</MenuItem>
                                        </SelectFormsy>
                                        {/* <SelectFormsy
                        className="w-full md:w-3/4 mt-20 float-right"
                        type="text"
                        value=""
                        name="task_instrument"
                        ref="task_instrument"
                        label="Instrument Name"
                    >
                     {this.state.items.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </SelectFormsy> */}
                                        <Select
                                            className="w-full md:w-3/4 mt-32 float-right"
                                            name="task_instrument"
                                            placeholder="Search Instrument"
                                            value={this.state.jobItem}
                                            onChange={this.setJobItem}
                                            options={this.state.items}
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="task_instrument_name"
                                            ref="task_instrument_name"
                                            value=""
                                        />
                                        <TextFieldFormsy
                                            type="hidden"
                                            name="task_instrument_id"
                                            ref="task_instrument_id"
                                            value=""
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-1/4 mt-20 pr-12"
                                            type="number"
                                            name="task_qty"
                                            ref="task_qty"
                                            value="1"
                                            label="QTY"
                                        />
                                        <TextFieldFormsy
                                            className="w-full md:w-3/4 mt-20 float-right"
                                            type="text"
                                            value=""
                                            name="task_remark"
                                            ref="task_remark"
                                            label="Remarks"
                                        />
                                        <Button
                                            type="button"
                                            className="m-4 my-20 float-left"
                                            variant="raised"
                                            color="default"
                                            onClick={() => {
                                                this.addTask();
                                            }}
                                        >
                                            add task
                                            <Icon className="ml-12">send</Icon>
                                        </Button>
                                        <ReactTable
                                            className="-striped -highlight w-full"
                                            data={this.state.tasks}
                                            columns={[

                                                {
                                                    Header: "Code",
                                                    accessor: "task_code",
                                                },
                                                {
                                                    Header: "Instrument",
                                                    accessor: "task_instrument",
                                                },
                                                {
                                                    Header: "QTY",
                                                    accessor: "task_qty",
                                                },
                                                {
                                                    Header: "Remarks",
                                                    accessor: "task_remark",
                                                },
                                                {
                                                    Header: "",
                                                    width: 128,
                                                    Cell: row => (

                                                        <div className="flex items-center">
                                                            <IconButton
                                                                className='text-green'
                                                                onClick={(ev) => {
                                                                    this.openSubTaskDialog(row.original.sub_tasks);
                                                                }}
                                                            >
                                                                <Icon>remove_red_eye</Icon>
                                                            </IconButton>
                                                            {row.original.editable == false ? (

                                                                ""
                                                            )
                                                                : (
                                                                    <div className="flex items-center">

                                                                        <IconButton
                                                                            className='text-red'
                                                                            onClick={(ev) => {
                                                                                this.removeTask(row.original);
                                                                            }}
                                                                        >
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    )
                                                }
                                            ]}
                                            defaultPageSize={5}
                                            noDataText="No Tasks"
                                        />

                                    </div>

                                </div>

                            </DialogContent>

                        </Formsy>
                    </Dialog>

                    <Dialog open={this.state.openComposeDialog} fullWidth maxWidth="sm">

                        <AppBar className="flex w-full h-56" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Sub Tasks
                                </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeSubTaskDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <DialogContent className="p-24">
                            <ReactTable
                                className="-striped -highlight w-full"
                                data={this.state.subTasks}
                                columns={[

                                    {
                                        Header: "Code",
                                        accessor: "subTask_code",
                                    },
                                    {
                                        Header: "Instrument",
                                        accessor: "subTask_instrument",
                                    }
                                ]}
                                defaultPageSize={5}
                                noDataText="No Sub Tasks"
                            />
                        </DialogContent>
                        <DialogActions className="justify-right pl-16">

                        </DialogActions>
                    </Dialog>

                    {/* /////me */}

                    {/* <IconButton
                        onClick={(e) => {
                        if (row) {

                            // updateTradeId = row.original.superTradeId;
                            // updateTradeName = row.original.superTradeName;
                            // isActive = row.original.isActive;
                            this.setState({ delete: true });
                            id = row.original.id;
                            // alert(id);


                        }
                        }}

                        >
                        <Icon className="text-red-light">delete</Icon>
                        </IconButton> */}


                    {/* /////me */}

                    <Dialog
                        open={this.state.delete}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">Delete Profesional Qualification</DialogTitle>
                        <DialogContent>

                            <div>

                                <Formsy
                                    onValidSubmit={this.onDelete}
                                    onValid={this.enableButtonDelete}
                                    onInvalid={this.disableButtonDelete}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center"
                                >
                                    <TextFieldFormsy
                                        type="hidden"
                                        name="id"
                                        value={id}
                                    />

                                    <DialogActions>
                                        <Button onClick={this.handleCloseDelete} color="primary">
                                            Cancel
                                        </Button>

                                        <Button
                                            type="submit"
                                            variant="raised"
                                            color="primary"
                                            className="mx-auto mt-16 pb-15"
                                            aria-label="Edit"
                                        // disabled={!canEdit}
                                        >
                                            Change
                                        </Button>
                                    </DialogActions>
                                </Formsy>
                            </div>
                        </DialogContent>
                    </Dialog>


                </React.Fragment>
            )
        }
    }

    componentWillMount() {

        this.getCustomerList();

        var broker = [];

        axios.get(window.salesServer + '/broker/getBrokerList')
            .then(response => {

                for (let i = 0; i < response.data.brokers.length; i++) {

                    broker.push({
                        value: response.data.brokers[i].ID_SALES_BROKER,
                        label: response.data.brokers[i].NAME
                    });
                }
                this.setState({ brokers: broker });
            });

        //==============================================================================

        var employee = [];

        axios.get(window.hrmServer + '/getEmployeeNameId')
            .then(response => {

                for (let i = 0; i < response.data.result.length; i++) {

                    employee.push({
                        value: response.data.result[i].ID_EMPLOYEE_PROFILE,
                        label: response.data.result[i].FIRST_NAME + ' (' + response.data.result[i].DESIGNATION + ')'
                    });
                }
                this.setState({ employees: employee });
            });

        //==============================================================================

        var item = [];

        axios.get(window.inventoryServer + '/inventory/get/serviceNames')
            .then(response => {

                for (let i = 0; i < response.data.result.length; i++) {

                    item.push({
                        value: response.data.result[i].ID_ITEM,
                        label: response.data.result[i].GENERAL_NAME + ' [ Rs.' + response.data.result[i].RETAIL_PRICE + ' ]'
                    });
                }
                this.setState({ items: item });
            });
    }

}

export default withStyles(styles, { withTheme: true })(withAlert(jobsForCustomerView));


// WEBPACK FOOTER //
// ./src/main/content/crm/jobsForCustomerView/jobsForCustomerView.js